import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { ProduitsService } from 'app/services/produits/produits.service';
import { SousCategorieService } from 'app/services/sous-categorie/sous-categorie.service'; // 👈 import
import Swal from 'sweetalert2';

@Component({
  selector: 'app-coffee-list',
  templateUrl: './coffee-list.component.html',
  styleUrls: ['./coffee-list.component.scss']
})
export class CoffeeListComponent implements OnInit {
  idAgency: any;
  Agency: any;
  list: any[] = [];
  p: number = 1;
  loadingSousCat = false;

  constructor(
    private agencieService: AgenciesService,
    private activatedRoute: ActivatedRoute,
    private produitsService: ProduitsService,
    private sousCategorieService: SousCategorieService, // 👈 inject
    private location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    if (!this.idAgency) {
      this.location.back();
      return;
    }
    this.agencieService.setIdAgency(this.idAgency);
    this.loadAgencyDetails();
  }

  loadAgencyDetails(): void {
    this.agencieService.getAgencieById(this.idAgency).subscribe({
      next: (data: any) => {
        this.Agency = data;
        this.list = Array.isArray(data?.produits) ? data.produits : [];

        // ✅ Initialize sous_cat for each product
        this.list.forEach(p => p.sous_cat = []);

        // ✅ Load sub-products (sous-catégories)
        this.loadSousCategories();

        console.log('Agency:', this.Agency);
        console.log('List:', this.list);
      },
      error: (err) => {
        console.error('Erreur chargement agence:', err);
        Swal.fire({
          title: 'Erreur',
          text: 'Impossible de charger les produits.',
          icon: 'error'
        });
      }
    });
  }

  // ✅ Fetch all sous-catégories and attach to corresponding product
  loadSousCategories(): void {
    this.loadingSousCat = true;
    this.sousCategorieService.getListSousCategorie().subscribe({
      next: (allSousCats: any[]) => {
        const sousCatByProduct = new Map<number, any[]>();
        allSousCats.forEach(sc => {
          const productId = sc.produit_id || sc.produitId;
          if (productId) {
            if (!sousCatByProduct.has(productId)) {
              sousCatByProduct.set(productId, []);
            }
            sousCatByProduct.get(productId)!.push(sc);
          }
        });
        this.list.forEach(product => {
          product.sous_cat = sousCatByProduct.get(product.id) || [];
        });
        this.loadingSousCat = false;
      },
      error: (err) => {
        console.error('Failed to load sous-categories:', err);
        this.loadingSousCat = false;
      }
    });
  }

  deleteAgenciesProjet(produit: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimez-le !'
    }).then((result) => {
      if (result.isConfirmed) {
        this.produitsService.deleteProduit(produit.id).subscribe({
          next: () => {
            Swal.fire({
              title: 'Supprimé !',
              text: 'Le produit a été supprimé.',
              icon: 'success'
            });
            this.list = this.list.filter(p => p.id !== produit.id);
          },
          error: (err) => {
            console.error('Erreur suppression:', err);
            Swal.fire({
              title: 'Erreur',
              text: 'La suppression a échoué.',
              icon: 'error'
            });
          }
        });
      }
    });
  }

  navigateBack(): void {
    this.location.back();
  }
}